// services/tables.js
import { getSubdomain, fetchWithAuth } from "../../helpers";
import { API_PASSWORD } from "../../config";

export const fetchPendingReservationForTable = async (tableId) => {
  const subdomain = window.location.hostname.split(".")[0];
  const token = localStorage.getItem("token");
  if (!tableId) throw new Error("❌ يجب تحديد رقم الطاولة");

  const url = `https://${subdomain}.restocash.app/api/pending/reservation/table/${tableId}?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في جلب الحجوزات المعلقة للطاولة:", data);
    throw new Error(data?.message || "❌ فشل في جلب الحجوزات المعلقة للطاولة.");
  }

  return data.data; // مصفوفة الحجوزات المعلقة للطاولة
};

export const createOrderFromReservation = async (reservationId) => {
  const subdomain = window.location.hostname.split(".")[0];
  const token = localStorage.getItem("token");
  if (!reservationId) throw new Error("❌ يجب تحديد رقم الحجز");

  const url = `https://${subdomain}.restocash.app/api/make/order/of/reservation/${reservationId}?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في إنشاء الطلب من الحجز:", data);
    throw new Error(data?.message || "❌ فشل في إنشاء الطلب من الحجز.");
  }

  return data.data; // بيانات الطلب الناتج من الحجز
};

export const removeOfferFromOrder = async (orderId, offerId) => {
  const subdomain = window.location.hostname.split(".")[0];
  const token = localStorage.getItem("token");
  if (!orderId) throw new Error("❌ يجب تحديد رقم الطلب");
  if (!offerId) throw new Error("❌ يجب تحديد رقم العرض");

  const url = `https://${subdomain}.restocash.app/api/remove/offer/from/order/${orderId}/${offerId}?api_password=Project102$_`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ فشل في حذف العرض من الطلب:", data);
    throw new Error(data?.message || "❌ فشل في حذف العرض من الطلب.");
  }

  // استجابة الـ API تحتوي عادة رسالة نجاح؛ نعيدها لمستدعي الدالة
  return data?.message || data?.data;
};



